import { render, staticRenderFns } from "./answerAgain_mode.vue?vue&type=template&id=57fa2a5b&scoped=true"
import script from "./answerAgain_mode.vue?vue&type=script&lang=js"
export * from "./answerAgain_mode.vue?vue&type=script&lang=js"
import style0 from "./answerAgain_mode.vue?vue&type=style&index=0&id=57fa2a5b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57fa2a5b",
  null
  
)

export default component.exports